import { AppBar, IconButton, Menu, MenuItem, Toolbar, Typography } from "@material-ui/core";
import classNames from "classnames";
import { useState, useCallback } from "react";
import { DefaultProfile, PriceTracqLogo } from "../../../images";
import Image from "../image/image";
import styles from "./header.module.scss";
import KeyboardArrowDownRoundedIcon from "@material-ui/icons/KeyboardArrowDownRounded";
import { useApi } from "hooks";
import { redirectTo } from "utils";
import { logout } from "apis";
import { Path } from "enums";
import { useContext } from "react";
import { AppContext } from "contexts";
import { locale } from "localization/en";

const Header = ({ onClick }) => {
  const [open, setOpen] = useState(false);
  const { toggleLoading } = useContext(AppContext);

  const { request: logoutRequest } = useApi({
    api: logout,
  });

  const logoutCb = useCallback(async () => {
    toggleLoading(true);
    await logoutRequest();
    localStorage.removeItem("accessToken");
    localStorage.removeItem("refreshToken");
    toggleLoading(false);
    redirectTo(Path.Auth);
  }, [logoutRequest, toggleLoading]);

  const handleClose = () => {
    setOpen(false);
  };

  const handleOpen = () => {
    setOpen(true);
  };

  return (
    <div id="header">
      <AppBar className={classNames(styles.locqHeaderContainer)}>
        <Toolbar disableGutters>
          <div className={styles.logoContainer}>
            <Image src={PriceTracqLogo} className={styles.logo} />
          </div>
          <div className={styles.toolbarContainer}>
            <Typography variant="h6" className={styles.title}>
              {locale.stocqBOS}
            </Typography>
            <div className={styles.menuContainer}>
              <IconButton
                className={styles.profileDiv}
                aria-label="account of current user"
                aria-controls="menu-appbar"
                aria-haspopup="true"
                onClick={handleOpen}
              >
                <Image src={DefaultProfile} className={styles.profile} />
                <KeyboardArrowDownRoundedIcon className={styles.caretIcon} />
              </IconButton>
              <Menu
                anchorOrigin={{ vertical: "top", horizontal: "right" }}
                transformOrigin={{ vertical: "top", horizontal: "right" }}
                keepMounted
                open={open}
                className={styles.menu}
                onClose={handleClose}
              >
                <MenuItem className={styles.menuItem} onClick={logoutCb}>
                  {locale.logout}
                </MenuItem>
              </Menu>
            </div>
          </div>
        </Toolbar>
      </AppBar>
    </div>
  );
};

export default Header;
